<template>
    <v-dialog v-model="discountDialog" scrollable persistent max-width="500">
        <v-card>
          <v-card-title>
            <span class="headline"> {{discountDialogTitle}} Tipo Sconto</span>
          </v-card-title>
          <v-card-text>
            <v-form>
              <v-container grid-list>
                <v-layout wrap>
                  <v-flex xs3>
                    <v-text-field
                      v-model="newDiscountType.code"
                      label="Codice"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs9>
                    <v-text-field       
                      v-if="discountDialog" autofocus        
                      v-model="newDiscountType.name"
                      v-validate="'required'"
                      :error-messages="errors.first('discountForm.name')"
                      data-vv-name="name"
                      data-vv-scope="discountForm"
                      label="Nome"
                      required    
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6>
                      <v-radio-group 
                        v-model="newDiscountType.reference"
                        label="Riferimento"
                      >
                        <v-radio label="Sconto sul Totale" value="totale">
                        </v-radio>
                        <v-radio label="Sconto sul Articolo" value="articolo">
                        </v-radio>
                      </v-radio-group>
                  </v-flex>
                  <v-flex xs6>
                    <v-radio-group 
                      v-model="newDiscountType.isPercentage"
                      label="Tipo"
                    >
                      <v-radio label="Percentuale" value=true>
                      </v-radio>
                      <v-radio label="Fisso" value=false>
                      </v-radio>                
                    </v-radio-group>
                  </v-flex>
                  <v-flex xs3>
                    <v-text-field
                      height="28"
                      mask="##,##"
                      placeholder="00,00"
                      :return-masked-value=true
                      v-model="newDiscountType.value"
                      v-validate="{ rules: { decimal: [2, ','] } }"
                      :error-messages="errors.first('discountForm.value')"
                      data-vv-name="value"
                      data-vv-scope="discountForm"
                      label="Valore"
                      v-bind="modifyDiscountValueField"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs9>
                    <v-combobox
                      v-model="newDiscountType.group"
                      v-validate="'required'"                
                      :items="discountGroupNames"
                      :error-messages="errors.first('discountForm.group')"
                      data-vv-name="group"
                      data-vv-scope="discountForm"
                      label="Gruppo"
                      placeholder="Cerca un gruppo o crea uno nuovo"                
                      required
                    ></v-combobox>                    
                  </v-flex>
                </v-layout>
              </v-container>
              <v-text-field
                v-model="newDiscountType.id"
                v-show=false
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error darken-1" flat @click="closeDiscountDialog">Annulla</v-btn>
            <v-btn color="success darken-1" flat @click="saveDiscountType">Salva</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
</template>
<script>
import uuidv4 from "uuid/v4";
export default {
    name: 'discountDialog',
    props:[
        'discountDialog', 'newDiscountType', 'discountDialogTitle', 'discounts'
    ],
    computed: {
        modifyDiscountValueField() {
            if (this.newDiscountType.isPercentage == "true") {
                return { suffix: '%' };
            } else {
                return { suffix: '€' };
            }
        },    
        discountGroupNames: function(){
            let computedDiscounts = Object.assign(this.discounts);
            let groupArray = computedDiscounts.filter( (value, index, self) => {
                return index === self.findIndex((element) => {
                    return element.group === value.group 
                });        
            });

            var mappedGroup = groupArray.map(element => element.group);
            return mappedGroup;
        }, 
    },
    methods: {        
        closeDiscountDialog() {  
            this.$validator.reset('discountForm');  
            this.newDiscountType.name = '';
            this.newDiscountType.reference = 'totale';
            this.newDiscountType.isPercentage = true;
            this.newDiscountType.code = '';
            this.newDiscountType.value = '';
            this.newDiscountType.id = '';
            this.newDiscountType.group = '';
            this.$emit('closeDiscountDialog', false);
        },
        saveDiscountType() {
            let message;
            let done = false;
            let vm = this;

            //workaround to be able to submit form with group combobox not doing the blur event
            setTimeout(() => {
                this.$validator.validate('discountForm.*').then((result) => {
                    if (result) {
                        if (this.newDiscountType.id) {
                            //find the object in the array served by the DB and update it.
                            this.discounts.forEach((discount, index, discounts) => {
                                if (discount.id == vm.newDiscountType.id && !done) {
                                    if (vm.newDiscountType.value) {
                                        vm.newDiscountType.value = parseFloat(vm.newDiscountType.value.replace(',','.'));
                                    } else {
                                        vm.newDiscountType.value = 0;
                                    }
                                    this.newDiscountType.isPercentage = this.newDiscountType.isPercentage == 'true' ? true : false; 
                                    vm.discounts.splice(index, 1, utils.clone(vm.newDiscountType));
                                    done = true;
                                }
                            });
                            message = 'Sconto modificato. Ricorda di salvare le impostazioni.';               
                        } else {     
                        //find the object in the array served by the DB and update it.
                            this.newDiscountType.id = uuidv4();
                            if (vm.newDiscountType.value) {
                                vm.newDiscountType.value = parseFloat(vm.newDiscountType.value.replace(',','.'));
                            } else {
                                vm.newDiscountType.value = 0;
                            }
                            this.newDiscountType.isPercentage = this.newDiscountType.isPercentage == 'true' ? true : false; 
                            this.discounts.push(utils.clone(this.newDiscountType));
                            message = 'Sconto inserito. Ricorda di salvare le impostazioni.';         
                        }
                        this.closeDiscountDialog();
                        this.$store.dispatch('PUSH_MESSAGE', message); 
                    } 
                });
            });      
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/components/common/DiscountDialog.vue